import { george, pr, React, theme, i18n } from "aaa";
import { ui } from "components/util/uiHelpers";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

type IProps = {
    title?: string;
    content: React.ReactNode;
    style?: React.CSSProperties
};

export const InfoBox = (props: IProps) => (
    <george.Card style={{ borderStyle: "solid", borderWidth: 1, borderColor: theme.themeColors.ui_blue, ...props.style }}>
        <pr.HFlex>
            <div style={{ paddingLeft: theme.MARGIN, paddingTop: theme.MARGIN + 2 }}>
                <pr.IconInfoCircleHollow style={{ color: theme.themeColors.ui_blue, width: 16, height: 16 }} />
            </div>
            <div>
                {props.title &&
                    <george.CardSectionTitle
                        title={props.title}
                        style={{ paddingLeft: theme.MARGIN_SMALL, paddingBottom: theme.MARGIN_SMALL }}
                    />
                }
                <george.CardSectionContent style={{ paddingLeft: theme.MARGIN_SMALL, paddingTop: props.title ? undefined : theme.MARGIN }}>
                    {props.content}
                </george.CardSectionContent>
            </div>
        </pr.HFlex>
    </george.Card>
);



// WEBPACK FOOTER //
// ./src/components/common/InfoBox.tsx